import { Base } from 'src/models/base';
import { PromoModelBase } from './promoModelBase';
export class Activity extends Base{
    priority: number;
    dateFrom: string;
    dateTo: string;
    promoCategory: Base[] | -1;
    promoRegions: Base[] | -1;
    promoModels: PromoModelBase[];
}